import { Dayjs } from 'dayjs';
import { useMemo, useState } from 'react';
import { RangeEventValue } from 'src/utils/date-util';

const useDateForTableOptions = (
  dateParser: (left: Dayjs, right: Dayjs) => [string, string],
  defaultValue: [Dayjs, Dayjs]
) => {
  const [dates, setDates] = useState<RangeEventValue>(defaultValue);
  const [leftDate, rightDate] = useMemo(() => {
    return dates?.[0] && dates?.[1] ? dateParser(dates[0], dates[1]) : dateParser(defaultValue[0], defaultValue[1]);
  }, [dateParser, dates, defaultValue]);

  return { dates, setDates, leftDate, rightDate };
};

export default useDateForTableOptions;
